import { useCompositeBalance } from '../store/compositeSelectors/useCompositeBalance';
import { useSessionBalanceConfig } from '../store/compositeSelectors/useSessionBalanceConfig';
import { useConfigSlice } from '../store/slices/config/selectors';

export const useFormattedBalanceConnected = (): string => {
  const balance = useCompositeBalance()?.amount;
  const compliance = useConfigSlice.compliance();
  const sessionBalance = useSessionBalanceConfig();
  const sessionBalanceWasSet = compliance?.sessionBalanceWasSet;

  if (balance === undefined) return '';

  return sessionBalance && !sessionBalanceWasSet && balance > 0 ? '-' : String(balance);
};
